var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgExternalSourceCategory = function SvgExternalSourceCategory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ExternalSourceCategory_svg__ExternalSourceCategory_svg__clip0_1496_7846)",
    stroke: "#6E7D8C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.792 9.126L9 11.988l2.792 2.862M20 12H10"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.127A9 9 0 1120.064 8",
    stroke: "#6E7D8C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ExternalSourceCategory_svg__ExternalSourceCategory_svg__clip0_1496_7846"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 23,
    width: 22,
    height: 22,
    rx: 4,
    transform: "rotate(-180 23 23)",
    fill: "#fff"
  })))));
};
export default SvgExternalSourceCategory;